export default function focus(selector) {
    let el = document.querySelector(selector);
    console.log('focus', el);
    if(el instanceof HTMLElement) {
        el.focus();
    }
}